const API_BASE_URL = (process.env.VUE_APP_API_BASE_URL || '/api').replace(/\/$/, '');

async function request(path, options = {}) {
    const response = await fetch(`${API_BASE_URL}${path}`, {
        headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
        ...options
    });

    const raw = await response.text();
    let data = null;
    if (raw) {
        try {
            data = JSON.parse(raw);
        } catch (error) {
            data = raw;
        }
    }

    if (!response.ok) {
        const detail = data && typeof data === 'object' ? data.detail : data;
        const message = typeof detail === 'string' ? detail : `Request failed (${response.status})`;
        throw new Error(message);
    }

    return data;
}

export const api = {
    getPlans: () => request('/payments/plans'),
    initializePayment: (payload) =>
        request('/payments/initialize', {
            method: 'POST',
            body: JSON.stringify(payload)
        }),
    verifyPayment: (reference, accessCode) => {
        const query = accessCode ? `?access_code=${encodeURIComponent(accessCode)}` : '';
        return request(`/payments/verify/${encodeURIComponent(reference)}${query}`);
    },
    getVideos: (folderPath) =>
        request(`/videos?folder_path=${encodeURIComponent(folderPath)}`),
    getPosts: (page = 1) =>
        request(`/posts/get_posts?page=${encodeURIComponent(page)}`),
    getPost: (id) =>
        request(`/posts/${encodeURIComponent(id)}`)
};

export { API_BASE_URL };
